export type ContentInput = Element | HTMLElement | string | null | undefined;

export abstract class ContentHelper {
  private readonly available: boolean;

  protected constructor() {
    this.available = this.isAvailable();
  }

  protected getTextFromNode(element: Node) {
    return worker(element);

    function worker(node: Node, text = '') {
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.nodeValue;
        text += '\n';
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (
          node.nodeName === 'BR' &&
          node.nextSibling?.nodeType !== Node.TEXT_NODE
        ) {
          text += '\n';
        }
        for (const child of Array.from(node.childNodes)) {
          text = worker(child, text);
        }
      }
      return text;
    }
  }

  protected getNode(elementOrId: ContentInput): Element {
    if (!this.isAvailable) {
      throw new Error('Unsupported');
    }

    if (!elementOrId) {
      throw new Error('No input provided');
    }

    let element = elementOrId;
    if (typeof elementOrId === 'string') {
      const e = document.getElementById(elementOrId);
      if (!e) {
        throw new Error(`Element ${elementOrId} not found`);
      }
      element = e;
    }

    return element as Element;
  }

  protected abstract isAvailable(): boolean;
}
